<template>
  <div
    class="toast-container"
    :style="containerStyle"
    v-if="messages.length > 0"
  >
    <!-- <div class="debug-info">
      Messages count: {{ messages.length }} | Last message: {{ messages[messages.length - 1]?.detail || 'None' }}
    </div> -->
    <transition-group name="toast" tag="div">
      <div
        v-for="message in messages"
        :key="message.id"
        class="toast-message"
        :class="`toast-${message.severity}`"
        role="alert"
        @click="removeToast(message.id)"
      >
        <div class="toast-content">
          <i :class="getIconClass(message.severity)" class="toast-icon"></i>
          <div class="toast-text">
            <!-- <span v-if="message.summary" class="toast-summary">{{
              message.summary
            }}</span> -->
            <span class="toast-detail" v-if="message.detail">{{
              message.detail
            }}</span>
            <span v-else class="toast-detail">[No detail]</span>
          </div>
          <button
            class="toast-close"
            @click.stop="removeToast(message.id)"
            aria-label="Close"
          >
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import toastService from "@/services/toast";

export default {
  name: "ToastMessage",
  props: {
    position: {
      type: String,
      default: "top-right",
      validator: (value) =>
        [
          "top-right",
          "top-left",
          "bottom-right",
          "bottom-left",
          "top-center",
          "bottom-center",
          "center",
        ].includes(value),
    },
    autoDismiss: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      messages: [],
    };
  },
  computed: {
    containerStyle() {
      const styles = {
        position: "fixed",
        zIndex: 10000,
        maxWidth: "400px",
        minWidth: "200px",
        backgroundColor: "rgba(255, 0, 0, 0.2)",
        top: "20px !important",
        right: "107px !important",
      };
      // console.log("Computed messages:", this.messages);
      return styles;
    },
  },
  watch: {
    // messages: {
    //   handler(newMessages) {
    //     console.log("Messages updated (watch):", newMessages);
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  created() {
    this.syncMessages();
    // Subscribe to toastService changes
    this.unsubscribe = toastService.subscribe(() => {
      // console.log("Toast service notified of change");
      this.syncMessages();
    });
    // Optional: Keep the $watch as a fallback
    this.$watch(
      () => [...toastService.getMessages()],
      (newMessages) => {
        // console.log("Raw toastService messages:", toastService.getMessages());
        this.messages = [...newMessages];
        // console.log("External messages updated:", this.messages);
      },
      { deep: true, immediate: true }
    );
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe(); // Clean up subscription
    }
  },
  methods: {
    syncMessages() {
      const messages = toastService.getMessages();
      if (JSON.stringify(this.messages) !== JSON.stringify(messages)) {
        this.messages = [...messages];
        // console.log("Synced messages:", this.messages);
      }
    },
    removeToast(id) {
      toastService.remove(id);
      this.syncMessages();
    },
    getIconClass(severity) {
      switch (severity) {
        case "success":
          return "icon-check";
        case "info":
          return "icon-info";
        case "warn":
          return "icon-warning";
        case "error":
          return "icon-error";
        default:
          return "icon-info";
      }
    },
  },
  // mounted() {
  //   // console.log("ToastMessage mounted");
  // },
};
</script>

<style lang="scss">
/* Removed scoped for debugging */
.toast-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: auto;
  position: fixed !important;
  top: 20px !important;
  right: 107px !important;
  z-index: 10000 !important;
}

.debug-info {
  color: white;
  font-size: 12px;
  padding: 5px;
  background: rgba(0, 0, 0, 0.5);
}

.toast-message {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  font-family: "voyado Text", sans-serif;
  font-size: 14px;
  color: #21211f;
  border-left: 4px solid;
  min-width: 200px;
  min-height: 50px;
  border: 4px solid #ffffff;
  display: flex !important;
  flex-direction: column;
  pointer-events: auto;
  animation: none !important;
}

.toast-success {
  width: 500px;
  height: 71px;
  padding: 24px;
  gap: 16px;
  border-radius: 8px;
  border-width: 4px;
  top: 202px;
  left: 20px;
  background: #edf8f4;
}

.toast-info {
  border-left-color: #3b82f6;
}

.toast-warn {
  width: 500px;
  height: 71px;
  padding: 24px;
  gap: 16px;
  border-radius: 8px;
  border-width: 4px;
  top: 202px;
  left: 20px;
  background: #FEFAE6;
}

.toast-error {
  width: 500px;
  height: auto;
  padding: 24px;
  gap: 16px;
  border-radius: 8px;
  border-width: 4px;
  top: 202px;
  left: 20px;
  background: #ffeeec;
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: -11px;
}

.toast-icon {
  font-size: 1.2rem;
  line-height: 1;
}

.toast-text {
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
}

.toast-summary {
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.toast-detail {
  display: block;
  word-break: break-all;
  font-family: Voyado Text;
  font-weight: 400;
  font-size: 18px;
  line-height: 21.6px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.toast-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1rem;
  color: #6b7280;
  align-self: flex-end;
}

.toast-close:hover {
  color: #21211f;
}

.icon-check {
  background: url("../../assets/icons/toastsuccessCircle.svg");
  width: 23px;
  height: 23px;
  display: block;
  background-repeat: no-repeat;
  margin-left: -6px;
}

.icon-info::before {
  content: "\2139";
  color: #3b82f6;
  font-weight: bold;
}

.icon-warning {
  background: url("../../assets/icons/toast-warn.svg");
  width: 23px;
  height: 23px;
  display: block;
  background-repeat: no-repeat;
  margin-left: -6px;
}

.icon-error {
  background: url("../../assets/icons/Times-Circle.svg");
  width: 23px;
  height: 23px;
  display: block;
  background-repeat: no-repeat;
  margin-left: -6px;
}

.icon-close {
  background: url("../../assets/icons/Times.svg");
  width: 18px;
  height: 18px;
  display: block;
  background-repeat: no-repeat;
}

.icon-close:hover::before {
  color: #21211f;
}
</style>